module.exports = __webpack_public_path__ + "static/media/ico_ticket.be4a5354.svg";